"use client";

import { useEffect } from "react";

/**
 * Client-side product preference check. If no product has been selected
 * (no localStorage entry), redirects to /picker. Place this in auth layouts
 * or protected layouts to ensure users pick a product before proceeding.
 */
export function ProductGate() {
  useEffect(() => {
    // The admin impersonation landing (/auth/impersonate) must not be gated:
    // it establishes the session from a ?token= query param and then redirects
    // onward. Gating it would bounce to /picker and drop the token before the
    // landing ever runs.
    const path = window.location.pathname.replace(/\/$/, "");
    if (path.endsWith("/auth/impersonate")) {
      return;
    }
    const selected = localStorage.getItem("selectedPlatform");
    if (!selected) {
      window.location.replace("/picker");
    }
  }, []);
  return null;
}
